import React, { useState, useContext } from "react";
import { doSendVerifyType, doVerifyType, doResendOtp } from "@AUTH";
import { Form, Input, Button, Statistic, Modal, Row, Col, Result } from "antd";
import MaskedInput from "antd-mask-input";
import { CheckCircleOutlined } from "@ant-design/icons";
import { AuthContext } from "@CONTEXTS";
const { Countdown } = Statistic;
const VerifyAuthType = ({ email }) => {
  const { setToken } = useContext(AuthContext);
  const [visible, setVisible] = useState(true);
  const [emailForm] = Form.useForm();
  const [phoneForm] = Form.useForm();
  const [emailTimerFinished, setEmailTimerFinished] = useState(false);
  const [smsTimerFinished, setSmsTimerFinished] = useState(false);
  const [expiresAtStringEmail, setExpireAtStringEmail] = useState(null);
  const [expiresAtStringSms, setExpireAtStringSms] = useState(null);
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [verificationEmail, setVerificationEmail] = useState(null);
  const [verificationSms, setVerificationSms] = useState(null);
  const [authToken, setAuthToken] = useState(null);

  const sendEmail = async () => {
    try {
      setLoading(true);
      emailForm.validateFields().then(async (values) => {
        // const { email } = values;
        const verification = await doSendVerifyType({
          email,
          verifyType: "EMAIL",
        });

        if (verification) {
          setExpireAtStringEmail(verification?.expiresAt.toLocaleString());
          setVerificationEmail(verification);
        }
      });
      // SMS gönderme işlemi burada
    } catch (err) {
      console.error("Form validation error:", err);
    } finally {
      setLoading(false);
    }
  };

  const sendSms = async () => {
    try {
      setLoading(true);
      phoneForm.validateFields().then(async (values) => {
        const { phone } = values;
        const verification = await doSendVerifyType({
          email,
          verifyType: "SMS",
          phone: phone.replace(/\s+/g, ""),
        });
        if (verification) {
          setExpireAtStringSms(verification?.expiresAt.toLocaleString());
          setVerificationSms(verification);
        }
      });
      // SMS gönderme işlemi burada
    } catch (err) {
      console.error("Form validation error:", err);
    } finally {
      setLoading(false);
    }
  };

  const verifyEmail = async (val) => {
    try {
      setLoading(true);
      const verification = await doVerifyType({
        verificationId: verificationEmail.verificationId,
        verificationCode: val?.verificationCode,
      });
      if (verification?.success) {
        setIsEmailVerified(true);
        setAuthToken(verification.token);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  const verifySms = async (val) => {
    try {
      setLoading(true);
      const { phone } = phoneForm.getFieldsValue();
      const verification = await doVerifyType({
        verificationId: verificationSms.verificationId,
        verificationCode: val?.verificationCode,
        phone: phone.replace(/\s+/g, ""),
      });
      if (verification?.success) {
        setIsPhoneVerified(true);
        setAuthToken(verification.token);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  const onEmailTimerFinish = () => {
    setEmailTimerFinished(true);
  };
  const onSmsTimerFinish = () => {
    setSmsTimerFinished(true);
  };
  const resendSms = async () => {
    try {
      setLoading(true);
      const { phone } = phoneForm.getFieldsValue();
      const payload = {
        verificationId: verificationSms.verificationId,
        phone: phone.replace(/\s+/g, ""),
      };
      const response = await doResendOtp(payload);
      if (response) {
        setVerificationSms(response);
        setExpireAtStringSms(response.expiresAt.toLocaleString());
        setSmsTimerFinished(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const resendEmail = async () => {
    try {
      setLoading(true);
      const payload = {
        verificationId: verificationEmail.verificationId,
      };
      const response = await doResendOtp(payload);
      if (response) {
        setVerificationEmail(response);
        setExpireAtStringEmail(response.expiresAt.toLocaleString());
        setEmailTimerFinished(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const steps = [
    {
      title: "Bilgilendirme ve doğrulama",
      content: (
        <Row gutter={16}>
          <Col span={24}>
            <p style={{ width: "100%" }}>
              Hesap güvenliğinizi artırmak için 2 aşamalı doğrulamayı
              etkinleştiriyoruz.
              <br></br>
              Bundan sonraki girişlerinizde, e-posta adresinize veya cep
              telefonunuza gönderilen doğrulama kodu ile giriş yapmanız
              gerekecektir.
              <br></br>
              Devam edebilmek için iletişim bilgilerinizin güncel olduğunu teyit
              etmeniz gerekmektedir.
            </p>

            <Form
              layout="vertical"
              name="basic"
              onFinish={(val) => sendEmail(val)}
              style={{ width: "100%" }}
              form={emailForm}
            >
              <Row gutter={16}>
                <Col span={16}>
                  <Form.Item
                    name={"email"}
                    initialValue={email}
                    label="E-posta Adresi:"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen e-posta adresinizi giriniz!",
                      },
                    ]}
                  >
                    <Input placeholder="E-posta adresiniz" disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  {isEmailVerified ? (
                    <h4
                      style={{
                        color: "green",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        marginTop: 34,
                      }}
                    >
                      <CheckCircleOutlined />
                      Doğrulandı
                    </h4>
                  ) : (
                    <Form.Item>
                      <Button
                        block
                        style={{ marginTop: 30 }}
                        type="primary"
                        htmlType="submit"
                        disabled={verificationEmail}
                      >
                        Doğrulama kodu gönder
                      </Button>
                    </Form.Item>
                  )}
                </Col>
              </Row>
            </Form>
            {verificationEmail && !isEmailVerified && (
              <Form
                layout="vertical"
                name="basic"
                onFinish={(val) => verifyEmail(val)}
                style={{ width: "100%" }}
              >
                <Row gutter={16}>
                  <Col span={10}>
                    <Form.Item
                      name="verificationCode"
                      label="Doğrulama kodunuz:"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.reject(
                                "Lütfen doğrulama kodunu giriniz."
                              );
                            }

                            // OTP'nin 6 haneli olması gerektiğini kontrol et
                            if (value.length !== 6) {
                              return Promise.reject(
                                "Doğrulama kodu 6 haneli olmalıdır."
                              );
                            }

                            // OTP'nin sadece rakamlardan oluşması gerektiğini kontrol et
                            if (!/^\d{6}$/.test(value)) {
                              return Promise.reject(
                                "Doğrulama kodu yalnızca rakamlardan oluşmalıdır."
                              );
                            }

                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input maxLength={6} style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <div
                      style={{
                        marginTop: 28,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                      }}
                    >
                      Kalan süre:
                      <Countdown
                        value={expiresAtStringEmail}
                        format="mm:ss"
                        onFinish={() => onEmailTimerFinish()}
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <Form.Item>
                      {emailTimerFinished ? (
                        <Button
                          type="primary"
                          onClick={resendEmail}
                          block
                          loading={loading}
                          style={{
                            marginTop: 28,
                          }}
                          disabled={!emailTimerFinished}
                        >
                          Kodu Yeniden Gönder
                        </Button>
                      ) : (
                        <Button
                          type="primary"
                          htmlType="submit"
                          block
                          loading={loading}
                          style={{
                            marginTop: 28,
                          }}
                          disabled={emailTimerFinished}
                        >
                          Kodu Doğrula
                        </Button>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            )}

            <Form
              layout="vertical"
              name="basic"
              onFinish={(val) => sendSms(val)}
              style={{ width: "100%" }}
              form={phoneForm}
            >
              <Row gutter={16}>
                <Col span={16}>
                  <Form.Item
                    name={"phone"}
                    label="Telefon Numarası:"
                    rules={[
                      {
                        required: true,
                        message: "Lütfen cep telefonu numarası giriniz!",
                      },
                      () => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject();
                          }
                          if (
                            value.includes("_") ||
                            /^[1-9][0-9]{9}$/.test(
                              value.replace(/\s+/g, "")
                            ) === false
                          ) {
                            return Promise.reject(
                              new Error(
                                "Lütfen cep telefonu numarasını başında 0 olmadan 10 haneli olacak şekilde uygun bir formatta giriniz!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <MaskedInput
                      mask="111 111 11 11"
                      size="10"
                      disabled={isPhoneVerified || verificationSms}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  {isPhoneVerified ? (
                    <h4
                      style={{
                        color: "green",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        marginTop: 34,
                      }}
                    >
                      <CheckCircleOutlined />
                      Doğrulandı
                    </h4>
                  ) : (
                    <Form.Item>
                      <Button
                        block
                        style={{ marginTop: 30 }}
                        type="primary"
                        htmlType="submit"
                        disabled={verificationSms}
                      >
                        Doğrulama kodu gönder
                      </Button>
                    </Form.Item>
                  )}
                </Col>
              </Row>
            </Form>
            {verificationSms && !isPhoneVerified && (
              <Form
                layout="vertical"
                name="basic"
                onFinish={(val) => verifySms(val)}
                style={{ width: "100%" }}
              >
                <Row gutter={16}>
                  <Col span={10}>
                    <Form.Item
                      name="verificationCode"
                      label="Doğrulama kodunuz:"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.reject(
                                "Lütfen doğrulama kodunu giriniz."
                              );
                            }

                            // OTP'nin 6 haneli olması gerektiğini kontrol et
                            if (value.length !== 6) {
                              return Promise.reject(
                                "Doğrulama kodu 6 haneli olmalıdır."
                              );
                            }

                            // OTP'nin sadece rakamlardan oluşması gerektiğini kontrol et
                            if (!/^\d{6}$/.test(value)) {
                              return Promise.reject(
                                "Doğrulama kodu yalnızca rakamlardan oluşmalıdır."
                              );
                            }

                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input maxLength={6} style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <div
                      style={{
                        marginTop: 28,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                      }}
                    >
                      Kalan süre:
                      <Countdown
                        value={expiresAtStringSms}
                        format="mm:ss"
                        onFinish={() => onSmsTimerFinish()}
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <Form.Item>
                      {smsTimerFinished ? (
                        <Button
                          type="primary"
                          onClick={resendSms}
                          block
                          loading={loading}
                          style={{
                            marginTop: 28,
                          }}
                        >
                          Kodu Yeniden Gönder
                        </Button>
                      ) : (
                        <Button
                          type="primary"
                          htmlType="submit"
                          block
                          loading={loading}
                          style={{
                            marginTop: 28,
                          }}
                          disabled={smsTimerFinished}
                        >
                          Kodu Doğrula
                        </Button>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            )}
            <Row align="end">
              <Button
                type="primary"
                disabled={!isEmailVerified && !isPhoneVerified}
                onClick={() => setStep(1)}
              >
                İlerle
              </Button>
            </Row>
          </Col>
        </Row>
      ),
    },

    {
      title: "Sonuç",
      content: (
        <Result
          status={isPhoneVerified || isEmailVerified ? "success" : "error"}
          title={"Doğrulama başarılı"}
          subTitle={
            !isPhoneVerified || !isEmailVerified
              ? "İletişim bilgilerinizden en az biri başarıyla doğrulandı."
              : "İletişim bilgileriniz başarı ile doğrulandı."
          }
          extra={[
            isPhoneVerified && (
              <span key="phone" style={{ color: "#52c41a" }}>
                ✔ Telefon numarası doğrulandı
              </span>
            ),
            isEmailVerified && (
              <span key="email" style={{ color: "#52c41a" }}>
                ✔ E-posta doğrulandı
              </span>
            ),
          ]}
        />
      ),
    },
  ];

  return (
    <Modal
      visible={visible}
      closable={step === 1}
      title={"İletişim bilgisi doğrulama"}
      width={750}
      centered
      maskClosable={step === 1}
      footer={null}
      onCancel={() => {
        setVisible(false);
        sessionStorage.removeItem("channel");
        setToken(authToken);
      }}
    >
      {steps[step].content}
    </Modal>
  );
};

export default VerifyAuthType;
